import classnames from 'classnames';
import type { CollapseProps } from 'antd';
import { Collapse } from 'antd';
import { useCallback, useEffect, useRef, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from '@/locales/init'; 
import {saveAnswerList as saveAnswerListListen} from '@/api/listen';
import {saveAnswerList as saveAnswerListReading} from '@/api/reading';
import {saveAnswerList as saveAnswerListWriting} from '@/api/writing';

import {IItem} from '@/api/start';
import style from './index.module.less';
import './index.less';


export default function OneTest(props: IItem & {title: string; enable: boolean;videoUrl: string; time: string; recordId: string; target: number; showScore: boolean; statusUpdating?: boolean;}) {

  const navigate = useNavigate();
  const {title, status = 1, score, is_confirm, enable, videoUrl, time, recordId, target, showScore, statusUpdating = false, submission_pending} = props || {};
  const statusTextArr = ['', 'Not completed', 'Not completed', 'Completed', 'Completed'];
  const statusClassList = ['', 'noCompleted', 'noCompleted', 'Completed', 'Completed'];
  const writingSubmissionComplete = title === 'Writing' && status === 3 && submission_pending === false;
  const statusText = statusUpdating && status < 3 ? i18n.t('common.dauyan_exam_status_updating') :
    writingSubmissionComplete ? i18n.t('common.dauyan_exam_submitted') :
      title === 'Writing' && status === 3 && submission_pending === true ? i18n.t('common.dauyan_exam_submission_processing') :
        title === 'Writing' && status === 3 ? i18n.t('common.dauyan_exam_submission_checking') : statusTextArr[status];
  const statusClass = title === 'Writing' && status === 3 && !writingSubmissionComplete ? 'noCompleted' : statusClassList[status];

  
  const [isConfirm, setIsConfirm] = useState(is_confirm === 1);
  const activeRecordIdRef = useRef(recordId);
  activeRecordIdRef.current = recordId;
  useEffect(() => {
    setIsConfirm(is_confirm === 1);
  }, [is_confirm, recordId]);
  const confirmStatusTxt = isConfirm ? 'Confirmed.' : 'Not confirmed.';
  const confirmStatusClass = isConfirm ? 'isConfirm' : 'noConfirm';
  

  const setConfirmTrueHandle = useCallback(() => {
    if (title === 'Listening') {
      saveAnswerListListen({is_confirm: 1, record_id: Number(recordId)}).then((res) => {
        if (res.code === 200 && activeRecordIdRef.current === recordId) {
          setIsConfirm(true);
        }
      });
    } else if (title === 'Reading') {
      saveAnswerListReading({is_confirm: 1, record_id: Number(recordId)}).then((res) => {
        if (res.code === 200 && activeRecordIdRef.current === recordId) {
          setIsConfirm(true);
        }
      });
    } else if (title === 'Writing') {
      saveAnswerListWriting({is_confirm: 1, record_id: Number(recordId)}).then((res) => {
        if (res.code === 200 && activeRecordIdRef.current === recordId) {
          setIsConfirm(true);
        }
      });
    }

  }, [recordId, title]);

  const startHandle =() => {
    navigate(`/mock${title.toLowerCase()}/${recordId}`);
  };

  const collapseHeader = (
    <div className={style.collapseHeader}>
      <div className={style.collapseHeaderTxt}>Test information.</div>
      <div className={classnames(style.confirmStatus, style[confirmStatusClass])}>{confirmStatusTxt}</div>
    </div>
  );

  const collapseChildren = (
    <div>
      <video controls className={style.video}>
        <source src={videoUrl} /> 
      </video>
      
      {
        !isConfirm ?
          <>
            <div className={style.ready}>Ready?</div>
            <p className={style.please}>Please confirm that you have understood the instructions above.</p>
            <button onClick={setConfirmTrueHandle} className={style.button} >
              <svg className={style.icon} width="1.125rem" height="1.125rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
        I confirm
            </button>
          </> : null
      }
    </div>
  );

  const getItems: () => CollapseProps['items'] = () => [
    {
      key: '1',
      label: collapseHeader,
      children: collapseChildren,
    },
    // {
    //   key: '2',
    //   label: collapseHeader,
    //   children: <div>123</div>,
    //   style: panelStyle,
    // }
  ];

  const toAI =() => {
    navigate(`/mock${title.toLowerCase()}ai/${recordId}`);
  };

  

  return (
    <div className={style.OneTest}>
      <div className={style.title}>
        
        {title}
      </div>
      <div className={classnames(style.completionStatus, style[statusClass])}>{statusText}<div className={style.scoreBox}>
        {
          showScore && status === 4&&<>
            <div className={classnames(style.score, score >= target ? style.level1: score >= target - 0.5 ? style.level2 : style.level3)}>{score}{i18n.t('common.dauyan_score')}</div>
            <div className={classnames(style.aiParsing, style.point)} onClick={toAI}>{title === 'Writing' ? i18n.t('common.dauyan_view_feedback') : i18n.t('common.dauyan_view_ai_explained')}</div>
          </>
        }
        {
          writingSubmissionComplete && <div className={style.aiParsing}>{i18n.t('common.dauyan_exam_submitted_awaiting_score')}</div>
        }
        {
          status === 3 && title !== 'Writing' && <>
            <div className={style.aiParsing}>{i18n.t('common.dauyan_scoring')}</div>
          </>
        }
        {
         
          (status === 4 || (status === 3 && (title !== 'Writing' || writingSubmissionComplete))) && <svg xmlns="http://www.w3.org/2000/svg" width="59" height="45.266" viewBox="0 0 59 45.266">
            <g id="Done" transform="translate(168.4 129.2)">
              <g id="Group_5772" data-name="Group 5772" transform="translate(-168.4 -129.2)">
                <path id="Path_19964" data-name="Path 19964" d="M30.621,93.81a5.247,5.247,0,0,1,0,7.287l-4.064,4.064a5.247,5.247,0,0,1-7.287,0L1.471,87.223a5.247,5.247,0,0,1,0-7.287l4.064-4.064a5.247,5.247,0,0,1,7.287,0Z" transform="translate(0 -61.367)" fill="#aebe36"/>
                <path id="Path_19965" data-name="Path 19965" d="M111.5,1.471a5.247,5.247,0,0,1,7.287,0l4.064,4.064a5.247,5.247,0,0,1,0,7.287L92.023,43.514a5.247,5.247,0,0,1-7.287,0L80.671,39.45a5.247,5.247,0,0,1,0-7.287Z" transform="translate(-65.326)" fill="#aebe36"/>
              </g>
            </g>
          </svg>
        }
        
      </div></div>
      <div className={style.timeLength}>Timing: <span className={style.timeNumber}>{time} minutes</span></div>
      {enable && !statusUpdating && status < 3&& <Collapse
        bordered={true}
        expandIcon={({ isActive }) => <div className={classnames(isActive ? style.arrowTop : style.arrowBottom, style.arrow)}></div>}
        items={getItems()}
        className="myCollapse"
      />}
      {
        isConfirm && enable && !statusUpdating && status < 3 ?
          <button className={classnames(style.button, style.confirmButton)} onClick={startHandle}>
            <svg className={style.icon} width="1.125rem" height="1.125rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
              <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
            </svg>
      Start {title}
          </button>
          :
          null
          
      }
      
    </div>
    
  );
}
